import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery"
import { getprojectbasicinfo, addprojectinchargeinfo, putprojectinchargeinfo } from "../../../../actions/AddNewProjectAction"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Delete from "../../../../assets/img/svg/delete.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import del from "../../../../assets/img/svg/Del.svg"
import Autocomplete from "react-autocomplete";

class AddIC extends Component {
    constructor(props) {
        super(props)
        this.state = {
            shipOwnerName: [],
            supervisorName: [],
            supervisorEmail: [],
            yardInchargeName: [],
            shipOwnerList: [],
            supervisorList: [],
            yardInchargeList: [],
            ShipOwnerUserId: 0,
            yardInchargeUserId: 0,
            supervisorUserId: 0,
            User_Table: [],
            isMobile: false,
            menu: true,
            isEdit: false,
            isshipOwnerExist: false,
            isyardInchargeExist: false,
            issupervisorExist: false,
            isshipError: false,
            isyardError1: false,
            isyardError2: false,
            issupervisorError1: false,
            issupervisorError2: false,
            cancel: false,
            ProjectName: "New Project",
            AccessToken: "",
            addData: {
                "ProjectId": 0,
                "ShipOwnerId": "",
                "ShipOwnerName": "",
                "ShipOwnerEmailId": "",
                "YardInChargeId": "",
                "YardInChargeName": "",
                "YardInChargeMailId": "",
                "YardName": "",
                "SupervisorId": "",
                "SuperVisorName": "",
                "SuperVisorMailId": "",
                "MonitoringCompany": "",
                "ActionBy": "",
                "SortBy": '',
                "SortOrder": 'asc'
            },
            shipData: {
                "PageNumber": 1,
                "PageSize": 100,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "ContactNumber": "",
                "Status": "",
                "RoleId": 2,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ProjectIds": [],
                "ProjectList": [],
                "SortBy": '',
                "SortOrder": 'asc'
            },
            supervisorData: {
                "PageNumber": 1,
                "PageSize": 100,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "MonitoringCompany": "",
                "ContactNumber": "",
                "Status": "",
                "RoleId": 4,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ProjectIds": [],
                "ProjectList": [],
                "SortBy": '',
                "SortOrder": 'asc'
            },
            yardData: {
                "PageNumber": 1,
                "PageSize": 100,
                "UserId": 0,
                "Name": "",
                "Email": "",
                "YardName": "",
                "ContactNumber": "",
                "Status": "",
                "RoleId": 3,
                "RoleName": "",
                "CreatedBy": "",
                "CreatedDate": "",
                "ProjectIds": [],
                "ProjectList": [],
                "SortBy": '',
                "SortOrder": 'asc'
            }
        }
        this.rendershipOwnerNames = this.rendershipOwnerNames.bind(this);
        this.renderyardInchargeNames = this.renderyardInchargeNames.bind(this);
        this.rendersupervisorNames = this.rendersupervisorNames.bind(this);
    };

    async componentDidMount() {
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        window.location.pathname === "/incharge/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.state.AccessToken = JSON.parse(localStorage.getItem("currentUser")).accessToken;
        this.state.ProjectName = localStorage.getItem("ProjectName");
        this.state.addData.ActionBy = localStorage.getItem("UserRoles");
        await this.getShipDetails(this.state.shipData);
        await this.getYardDetails(this.state.yardData);
        await this.getSupervisorDetails(this.state.supervisorData);
        this.setState({})
        if (this.state.isEdit == false) {
            if (localStorage.getItem("addeditid") != null) {
                await this.getprojectbasicinfo(localStorage.getItem("addeditid"))
            }
        }
        if (this.state.isEdit == true) {
            await this.getprojectbasicinfo(localStorage.getItem("DashId"))
        } else {
            this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
        this.props.dispatch({ type: "USER_TABLE", data: [] });

    }

    getprojectbasicinfo = async (data) => {
        let apiUrl = API.ADDEDIT_PROJECT + data;
        // this.props.dispatch({type:"SHOW_LOADER",data:true})
        await axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    localStorage.setItem("ProjectName", response.data?.ProjectName)
                    this.state.ProjectId = response.data.ProjectId;
                    this.state.addData.ProjectId = response.data.ProjectId;
                    this.state.addData.ShipOwnerName = response.data.ProjectUsers?.ShipOwnerName ? response.data.ProjectUsers?.ShipOwnerName : "";
                    this.state.addData.ShipOwnerEmailId = response.data.ProjectUsers?.ShipOwnerEmailId ? response.data.ProjectUsers?.ShipOwnerEmailId : "";
                    this.state.addData.YardInChargeName = response.data.ProjectUsers?.YardInChargeName ? response.data.ProjectUsers?.YardInChargeName : "";
                    this.state.addData.YardInChargeMailId = response.data.ProjectUsers?.YardInChargeMailId ? response.data.ProjectUsers?.YardInChargeMailId : "";
                    this.state.addData.YardName = response.data?.YardName ? response.data?.YardName : "";
                    this.state.addData.SuperVisorName = response.data.ProjectUsers?.SuperVisorName ? response.data.ProjectUsers?.SuperVisorName : "";
                    this.state.addData.SuperVisorMailId = response.data.ProjectUsers?.SuperVisorMailId ? response.data.ProjectUsers?.SuperVisorMailId : "";
                    this.state.addData.MonitoringCompany = response.data.ProjectUsers?.MonitoringCompany ? response.data.ProjectUsers?.MonitoringCompany : "";
                    this.setState({})
                    if (this.state.addData.ShipOwnerName !== "") {
                        let data = this.state.shipOwnerList.filter(x => x.Email === this.state.addData.ShipOwnerEmailId)
                        this.state.ShipOwnerUserId = data[0].UserId;
                        this.setState({})
                    }
                    if (this.state.addData.YardInChargeName !== "") {
                        let data1 = this.state.yardInchargeList.filter(x => x.Email === this.state.addData.YardInChargeMailId)
                        this.state.yardInchargeUserId = data1[0].UserId;
                        this.setState({})
                    }
                    if (this.state.addData.SuperVisorName !== "") {
                        let data2 = this.state.supervisorList.filter(x => x.Email === this.state.addData.SuperVisorMailId)
                        this.state.supervisorUserId = data2[0].UserId;
                        this.setState({})
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    getShipDetails = async (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        await axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {

                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.shipOwnerList.push(listItem);
                                this.state.shipOwnerName.push(i.Name);
                            }
                            this.setState({})
                        })

                    }

                }
            })
    }
    getYardDetails = async (data) => {
        let apiUrl = API.USER_MANAGEMENT;
        await axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, YardName: i.YardName, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.yardInchargeList.push(listItem);
                                this.state.yardInchargeName.push(i.Name);
                            }

                            this.setState({})
                        })

                    }
                }
            })
    }
    getSupervisorDetails = async (data) => {
        let apiUrl = API.USER_MANAGEMENT;

        await axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data?.Data.length > 0) {
                        response?.data?.Data.map((i) => {
                            if (i.Name != null && i.Name != undefined && i.Name != "" && i.Email != null && i.Email != undefined && i.Email != "") {
                                let listItem = { Name: i.Name, Email: i.Email, Company: i.MonitoringCompany, UserId: i.UserId, compain: i.Name + " (" + i.Email + ")" }
                                this.state.supervisorList.push(listItem);
                                this.state.supervisorName.push(i.Name);

                            }
                            this.setState({})
                        })

                    }
                }

            })
    }
    rendershipOwnerNames = (state, val) => {
        return state?.shipOwnerName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    rendersupervisorNames = (state, val) => {
        return state?.SuperVisorName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    renderyardInchargeNames = (state, val) => {
        return state?.YardInChargeName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#IC .MuiListItemText-primary").removeClass("fw-bolder")
        $("#ICL").removeClass("active-color")
    }

    // sidebar = () => {
    //     if (this.state.isEdit == true) {
    //         this.props.navigate("/sidebareditproject");
    //     }
    //     else {
    //         this.props.navigate("/sidebaraddproject");
    //     }
    // }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditproject");
            }
            else {
                this.props.navigate("/sidebaraddproject");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#InCharge1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#InCharge").removeClass("d-none");
        $("#InCharge").addClass("d-block");
        $("#IC .MuiListItemText-primary").addClass("fw-bolder")
        $("#ICL").addClass("active-color")
    }

    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        // this.state.addData[node] = e.target.value;
        // this.setState({})

        if (node === "ShipOwnerName") {
            let type = this.state.shipOwnerList.filter((i) => i.UserId === parseInt(e.target.value))

            if (type.length == 1) {
                this.state.ShipOwnerUserId = type[0].UserId
                this.state.addData.ShipOwnerName = type[0].Name
                this.state.addData.ShipOwnerEmailId = type[0].Email
                this.setState({})

            }
            else {
                this.state.ShipOwnerUserId = 0
                this.state.addData.ShipOwnerName = ""
                this.state.addData.ShipOwnerEmailId = ""
                this.setState({})
            }
            // this.state.shipOwnerList.map((item, index) => {
            //     if (item.Name === this.state.addData.ShipOwnerName) {
            //         this.state.isshipOwnerExist = true;
            //         this.state.addData.ShipOwnerEmailId = item.Email
            //     } else {
            //         this.state.isshipOwnerExist = false;
            //         this.state.addData.ShipOwnerEmailId = ""
            //     }
            // })
        } else if (node === "YardInChargeName") {
            let type = this.state.yardInchargeList.filter((i) => i.UserId === parseInt(e.target.value))
            if (type.length == 1) {
                this.state.yardInchargeUserId = type[0].UserId;
                this.state.addData.YardInChargeName = type[0].Name
                this.state.addData.YardInChargeMailId = type[0].Email;
                this.state.addData.YardName = type[0].YardName
                this.setState({})
            }
            else {
                this.state.yardInchargeUserId = 0;
                this.state.addData.YardInChargeName = "";
                this.state.addData.YardInChargeMailId = "";
                this.state.addData.YardName = "";
                this.setState({})
            }
            // this.state.yardInchargeList.map((item, index) => {
            //     if (item.Name === this.state.addData.YardInChargeName) {
            //         this.state.isyardInchargeExist = true;
            //         this.state.addData.YardInChargeMailId = item.Email
            //         this.state.addData.YardName = item.YardName
            //     } else {
            //         this.state.isyardInchargeExist = false;
            //         this.state.addData.YardInChargeMailId = "";
            //         this.state.addData.YardName = ""
            //     }
            // })
        } else if (node === "SuperVisorName") {
            let type = this.state.supervisorList.filter((i) => i.UserId === parseInt(e.target.value))
            if (type.length == 1) {
                this.state.supervisorUserId = type[0].UserId
                this.state.addData.SuperVisorName = type[0].Name
                this.state.addData.SuperVisorMailId = type[0].Email;
                this.state.addData.MonitoringCompany = type[0].Company;
                this.setState({})
            }
            else {
                this.state.supervisorUserId = 0
                this.state.addData.SuperVisorName = ""
                this.state.addData.SuperVisorMailId = ""
                this.state.addData.MonitoringCompany = ""
                this.setState({})
            }
            // this.state.supervisorList.map((item, index) => {
            //     if (item.Name === this.state.addData.SuperVisorName) {
            //         this.state.issupervisorExist = true;
            //         this.state.addData.SuperVisorMailId = item.Email
            //         this.state.addData.MonitoringCompany = item.Company
            //     } else {
            //         this.state.issupervisorExist = false;
            //         this.state.addData.SuperVisorMailId = "";
            //         this.state.addData.MonitoringCompany = "";
            //     }
            // })
        }
        this.setState({})
    };

    handleSelectChange = (e, node) => {
        if (node === "ShipOwnerName" && e !== "") {

            this.state.addData.ShipOwnerName = e;
            this.state.shipOwnerList.map((item, index) => {
                if (item.Name === this.state.addData.ShipOwnerName) {
                    this.state.isshipOwnerExist = true;
                    this.state.addData.ShipOwnerEmailId = item.Email
                }
            })
        } else if (node === "YardInChargeName" && e !== "") {
            this.state.addData.YardInChargeName = e;
            this.state.yardInchargeList.map((item, index) => {
                if (item.Name === this.state.addData.YardInChargeName) {
                    this.state.isyardInchargeExist = true;
                    this.state.addData.YardInChargeMailId = item.Email;
                    this.state.addData.YardName = item.YardName
                }
            })
        }
        else if (node == "SuperVisorName" && e !== "") {
            this.state.addData.SuperVisorName = e;
            this.state.supervisorList.map((item, index) => {
                if (item.Name === this.state.addData.SuperVisorName) {
                    this.state.issupervisorExist = true;
                    this.state.addData.SuperVisorMailId = item.Email;
                    this.state.addData.MonitoringCompany = item.Company
                }
            })
        }
        this.setState({})
    }

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/projectlist`)
        }
    }

    Save = () => {
        if (this.state.ProjectId !== 0 || this.state.ProjectId !== undefined) {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.setState({ cancel: false })
            this.props.dispatch(putprojectinchargeinfo(this.state.addData, this.state.AccessToken))

        } else {
            this.props.navigate(`/incharge/add`)
        }
        // }
    };

    fieldValidate = () => {
        const { ShipOwnerName, ShipOwnerEmailId, YardInChargeName, YardInChargeMailId, YardName, SuperVisorName, SuperVisorMailId, MonitoringCompany } = this.state.addData
        let errors = {};
        this.state.isshipError = false;
        this.state.isyardError1 = false;
        this.state.isyardError2 = false;
        this.state.issupervisorError1 = false;
        this.state.issupervisorError2 = false;
        if (ShipOwnerName !== null && ShipOwnerName !== "") {
            if (ShipOwnerEmailId === "") {
                errors.ShipOwnerEmailId = "Email is required"
                this.state.isshipError = true;
            }
            else {
                let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                let IsValidEmail = filter.test(ShipOwnerEmailId.toLowerCase());
                if (!IsValidEmail) {
                    errors.ShipOwnerEmailId = "please enter the valid email"
                    this.state.isshipError = true;
                }
            }
            this.setState({})
        }
        if (YardInChargeName !== null && YardInChargeName !== "") {
            if (YardInChargeMailId === "") {
                errors.YardInChargeMailId = "Yard Incharge Email is required"
                this.state.isyardError1 = true;
            }
            else {
                let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                let IsValidEmail = filter.test(ShipOwnerEmailId.toLowerCase());
                if (!IsValidEmail) {
                    errors.YardInChargeMailId = "please enter the valid email"
                    this.state.isyardError1 = true;
                }
            }
            if (YardName === "") {
                errors.YardName = "Recycling Yard Name is required"
                this.state.isyardError2 = true
            }
            this.setState({})
        }
        if (SuperVisorName !== null && SuperVisorName !== "") {
            if (SuperVisorMailId === "") {
                errors.SuperVisorMailId = "Supervisor Email is required"
                this.state.issupervisorError1 = true;
            }
            else {
                let filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                let IsValidEmail = filter.test(SuperVisorMailId.toLowerCase());
                if (!IsValidEmail) {
                    errors.SuperVisorMailId = "please enter the valid email"
                    this.state.issupervisorError1 = true;
                }
            }
            if (MonitoringCompany === "") {
                errors.MonitoringCompany = "Monitoring Company Name is required"
                this.state.issupervisorError2 = true;
            }
            this.setState({})
        }
        if (ShipOwnerName === "" && YardInChargeName === "" && SuperVisorName === "") {
            errors.empty = "All fields are empty"
        }
        return errors
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    };

    render() {
        const { isEdit } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"InCharge" + "1"} className='textNaviIcon f-size-13' primary={this.state.isEdit ? "Edit Project" : "New Project"} />
                                            <NavigateNextIcon id="InCharge" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">In Charge</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ProjectName}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-2" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Ship Owner Name&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <select
                                        fullWidth
                                        value={this.state.ShipOwnerUserId}
                                        style={{ height: "40px" }}
                                        className="form-control border-radius form-select"
                                        onChange={(e) => { this.handleInputChange(e, "ShipOwnerName") }}
                                    >
                                        <option value={0}>Select Ship Owner Name</option>
                                        {this.state.shipOwnerList &&
                                            this.state.shipOwnerList.map((i, ind) => {
                                                return <option value={i.UserId}>{i.compain}</option>
                                            })}
                                    </select>
                                    {/* <div className="autocomplete-wrappers">
                                        <Autocomplete
                                            contentEditable={true}  
                                            value={this.state.addData.ShipOwnerName}
                                            items={this.state.shipOwnerName ?? []}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            getItemValue={(item) => item}
                                            shouldItemRender={this.rendershipOwnerNames.bind(this)}
                                            renderMenu={(item) => (
                                                <div className="dropdowns d-block" >{item}</div>
                                            )}
                                            renderInput={(props) => {
                                                return (
                                                    <input
                                                        className="form-control border-radius"
                                                        id="exampleFormControlInput1"
                                                        {...props}
                                                        style={{ height: 35.21, fontSize: 12, color: "#000000" }}
                                                    />
                                                );
                                            }}
                                            renderItem={(item, isHighlighted) => (
                                                <div
                                                    className={`items
                                                                ${isHighlighted ? "selected-items" : ""
                                                        }`}
                                                >
                                                    {item}
                                                </div>
                                            )}
                                            onChange={(e) => { this.handleInputChange(e, "ShipOwnerName") }}
                                            onSelect={(e) => this.handleSelectChange(e, "ShipOwnerName")}
                                        />
                                    </div> */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Ship Owner Mail ID&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.ShipOwnerEmailId}
                                        onChange={(e) => { this.handleInputChange(e, "ShipOwnerEmailId") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    {/* {this.state.isshipOwnerExist === true ?
                                        <TextField
                                            disabled={true}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.ShipOwnerEmailId}
                                            onChange={(e) => { this.handleInputChange(e, "ShipOwnerEmailId") }}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                            }}
                                        /> :
                                        this.state.isshipError ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.ShipOwnerEmailId}
                                                onChange={(e) => { this.handleInputChange(e, "ShipOwnerEmailId") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.ShipOwnerEmailId}
                                                onChange={(e) => { this.handleInputChange(e, "ShipOwnerEmailId") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                    } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : " form-group m-0 text-right float-end"}>Yard Incharge Name&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <select
                                        fullWidth
                                        value={this.state.yardInchargeUserId}
                                        style={{ height: "40px" }}
                                        className="form-control border-radius form-select"
                                        onChange={(e) => { this.handleInputChange(e, "YardInChargeName") }}
                                    >
                                        <option value={0}>Select Yard Incharge Name</option>
                                        {this.state.yardInchargeName &&
                                            this.state.yardInchargeList.map((i, ind) => {
                                                return <option value={i.UserId}>{i.compain}</option>
                                            })}
                                    </select>
                                    {/* <div className="autocomplete-wrappers">
                                        <Autocomplete
                                            contentEditable={true}
                                            value={this.state.addData.YardInChargeName}
                                            items={this.state.yardInchargeName ?? []}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            getItemValue={(item) => item}
                                            shouldItemRender={this.renderyardInchargeNames.bind(this)}
                                            renderMenu={(item) => (
                                                <div className="dropdowns d-block" >{item}</div>
                                            )}
                                            renderInput={(props) => {
                                                return (
                                                    <input
                                                        className="form-control border-radius"
                                                        id="exampleFormControlInput1"
                                                        {...props}
                                                        style={{ height: 35.21, fontSize: 12, color: "#000000" }}
                                                    />
                                                );
                                            }}
                                            renderItem={(item, isHighlighted) => (
                                                <div
                                                    className={`items
                                                                ${isHighlighted ? "selected-items" : ""
                                                        }`}
                                                >
                                                    {item}
                                                </div>
                                            )}
                                            onChange={(e) => { this.handleInputChange(e, "YardInChargeName") }}
                                            onSelect={(e) => this.handleSelectChange(e, "YardInChargeName")}
                                        />
                                    </div> */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Yard In charge Email ID&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.YardInChargeMailId}
                                        onChange={(e) => { this.handleInputChange(e, "YardInChargeMailId") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    {/* {this.state.isyardInchargeExist === true ?
                                        <TextField
                                            disabled={true}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.YardInChargeMailId}
                                            onChange={(e) => { this.handleInputChange(e, "YardInChargeMailId") }}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                            }}
                                        /> :
                                        this.state.isyardError1 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.YardInChargeMailId}
                                                onChange={(e) => { this.handleInputChange(e, "YardInChargeMailId") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.YardInChargeMailId}
                                                onChange={(e) => { this.handleInputChange(e, "YardInChargeMailId") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                    } */}
                                </div>
                                {/* <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : " form-group m-0 text-right float-end"}>Recycling Yard&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.YardName}
                                        onChange={(e) => { this.handleInputChange(e, "YardName") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    {/* {this.state.isyardInchargeExist === true ?
                                        <TextField
                                            disabled={true}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.YardName}
                                            onChange={(e) => { this.handleInputChange(e, "YardName") }}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                            }}
                                        /> :
                                        this.state.isyardError2 ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.YardName}
                                                onChange={(e) => { this.handleInputChange(e, "YardName") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.YardName}
                                                onChange={(e) => { this.handleInputChange(e, "YardName") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                    } 
                                </div> */}
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Recycling Supervisor Name&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3 autocomplete-wrappers ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    <select
                                        fullWidth
                                        value={this.state.supervisorUserId}
                                        style={{ height: "40px" }}
                                        className="form-control border-radius form-select"
                                        onChange={(e) => { this.handleInputChange(e, "SuperVisorName") }}
                                    >
                                        <option value={0}>Select Supervisor Name</option>
                                        {this.state.supervisorList &&
                                            this.state.supervisorList.map((i, ind) => {
                                                return <option value={i.UserId}>{i.compain}</option>
                                            })}
                                    </select>
                                    {/* <div className="autocomplete-wrappers">
                                        <Autocomplete
                                            contentEditable={true}
                                            value={this.state.addData.SuperVisorName}
                                            items={this.state.supervisorName ?? []}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            getItemValue={(item) => item}
                                            shouldItemRender={this.rendersupervisorNames.bind(this)}
                                            renderMenu={(item) => (
                                                <div className="dropdowns d-block" >{item}</div>
                                            )}
                                            renderInput={(props) => {
                                                return (
                                                    <input
                                                        className="form-control border-radius"
                                                        id="exampleFormControlInput1"
                                                        {...props}
                                                        style={{ height: 35.21, fontSize: 12, color: "#000000" }}
                                                    />
                                                );
                                            }}
                                            renderItem={(item, isHighlighted) => (
                                                <div
                                                    className={`items
                                                                ${isHighlighted ? "selected-items" : ""
                                                        }`}
                                                >
                                                    {item}
                                                </div>
                                            )}
                                            onChange={(e) => { this.handleInputChange(e, "SuperVisorName") }}
                                            onSelect={(e) => this.handleSelectChange(e, "SuperVisorName")}
                                        />
                                    </div> */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Recycling Supervisor Email ID&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.SuperVisorMailId}
                                        onChange={(e) => { this.handleInputChange(e, "SuperVisorMailId") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    {/* {this.state.issupervisorExist === true ?
                                        <TextField
                                            disabled={true}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.SuperVisorMailId}
                                            onChange={(e) => { this.handleInputChange(e, "SuperVisorMailId") }}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                            }}
                                        /> :
                                        this.state.issupervisorError1 ?
                                            <TextField
                                                disabled={false}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.SuperVisorMailId}
                                                onChange={(e) => { this.handleInputChange(e, "SuperVisorMailId") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            /> :
                                            <TextField
                                                disabled={false}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.SuperVisorMailId}
                                                onChange={(e) => { this.handleInputChange(e, "SuperVisorMailId") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                    } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2   text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end"}>Ship Recycling Monitoring Company&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.MonitoringCompany}
                                        onChange={(e) => { this.handleInputChange(e, "MonitoringCompany") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    {/* {this.state.issupervisorExist === true ?
                                        <TextField
                                            disabled={true}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.MonitoringCompany}
                                            onChange={(e) => { this.handleInputChange(e, "MonitoringCompany") }}
                                            InputProps={{
                                                className: `border-radius view-color ${classes.inputfieldAlign}`
                                            }}
                                        /> :
                                        this.state.issupervisorError2 ?
                                            <TextField
                                                disabled={false}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.MonitoringCompany}
                                                onChange={(e) => { this.handleInputChange(e, "MonitoringCompany") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            /> :
                                            <TextField
                                                disabled={false}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.MonitoringCompany}
                                                onChange={(e) => { this.handleInputChange(e, "MonitoringCompany") }}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                    } */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        getprojectid: state.AddNewProjectReducer.getprojectid || [],
        getbasicinfo: state.AddNewProjectReducer.getbasicinfo || [],
        User_Table: state.UserReducer.User_Table,
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

AddIC.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddIC))
);